import { Observer } from '@dittolive/ditto'
import { useDitto } from '@dittolive/react-ditto'
import { useEffect, useRef, useState } from 'react'

type Params = {
  /** Ditto instance path passed to `useDitto` hook */
  path?: string
}

/**
 * Hook used to retrieve the connection status to the big peer
 * @returns true if a connection to the big peer is active, false otherwise
 */
export default function useDittoCloudConnectionStatus({
  path,
}: Params): boolean {
  const { ditto } = useDitto(path)
  const [isConnected, setIsConnected] = useState(false)
  const presenceObserverRef = useRef<Observer>()

  useEffect(() => {
    if (ditto) {
      presenceObserverRef.current = ditto.presence.observe(({ localPeer }) =>
        setIsConnected(localPeer.isConnectedToDittoCloud),
      )
    }

    return () => presenceObserverRef.current?.stop()
  }, [ditto])

  return isConnected
}
